import { Link, useNavigate } from "react-router-dom";
import { AiOutlineClose } from "react-icons/ai";
import x from "../../../assets/images/X.png";
import refermodal from "../../../assets/images/ReferalProgram/thankypomodal.webp";

import { useTranslation } from "react-i18next";
import { Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import {
  convertGlobalPrice,
  doc,
  updateReferalinUser,
} from "../../../utils/firebase/firebase.utils";
import { useContext, useEffect } from "react";
import { SetShowCongrats } from "../../../features/Flags/FlagsSlice";
import { UserContext } from "../../../context/user.context";

function ThankYouModal({ show, setShow }) {
  const { currentUser } = useContext(UserContext);
  const { i18n, t } = useTranslation();
  const { constant, referlength, updateReferral } = useSelector(
    (store) => store.flags
  );
  const { currencies, selectedcurrency, currencydefault, countryCode } =
    useSelector((store) => store.currency);

  const navigate = useNavigate();
  var nbentre510 = 10 - referlength;
  var nbpluspetit5 = 5 - referlength;

  function UpdateReferal(c) {
    const user = currentUser;
    var list = user.referralDismiss && user.referralDismiss.map((e) => e);
    if (user.referralDismiss == undefined) {
      list = [false, false, false, false];
    }
    try {
      if (user != null) {
        if (list.length > 0) {
          list[c] = true;
        }
        if (c === 3) {
          if (list[2] === false) {
            list[2] = true;
          }
          if (list[1] === false) {
            list[1] = true;
          }
          if (list[0] === false) {
            list[0] = true;
          }
        } else if (c === 2) {
          if (list[1] === false) {
            list[1] = true;
          }
          if (list[0] === false) {
            list[0] = true;
          }
        } else if (c === 1) {
          if (list[0] === false) {
            list[0] = true;
          }
        }

        if (currentUser) {
          updateReferalinUser(
            currentUser.uid,
            list.map((e) => e)
          );
        }
      }
    } catch (error) {
      // Handle error if needed
    }
  }

  return (
    <>
      <Modal
        // className="modal fade"
        // id="SignUp"
        // tabIndex="-1"
        // role="dialog"
        // aria-labelledby="SignUp"
        show={show}
        className="modal fade referalModal"
        centered
      >
        {/* <div
          className="modal-dialog modal-dialog-centered modal-signup"
          role="document"
        > */}
        <Modal.Body className="p-0 m-0 ">
          <div class="image-container">
            <img src={refermodal} className="imgreferal w-100" alt="Image" />
            <div class="text-overlayx ">
              <div>
                <button
                  type="button"
                  className="close close-txt close-modal align-items-center px-0"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => UpdateReferal(updateReferral) & setShow(false)}
                >
                  <img
                    src={x}
                    onClick={() =>
                      UpdateReferal(updateReferral) & setShow(false)
                    }
                    alt="main"
                    className="x-close "
                  />

                  {/* <img src={closeModal} onClick={()=>setShow(false)} className="ms-1 mb-1 close-btn2"/> */}
                </button>
              </div>
            </div>
          </div>

          <div
            className="modal-body p-0 mt-3 mb-3"
            style={{ cursor: "pointer" }}
            onClick={() => UpdateReferal(updateReferral)}
          >
            <div className="w-100 justify-content-center d-flex ">
              <div className="refralmodalsubtitlethx">
                {t("CONGRATS ON")}
                <br />
                {t("REFERRING A FRIEND")}
              </div>
            </div>

            <div className="w-100 justify-content-center d-flex pt-3 pb-3">
              <div className="refralmodalsubtitlethx">
                {referlength >= 10 ? null : t("KEEP IT UP")}
              </div>
            </div>

            <div className="justify-content-center d-flex w-100 text-center">
              <div className="px-4 refralmodalsubtitlethx2">
                {referlength < 10 ? (
                  <>
                    {t("thankstxt")}{" "}
                    {referlength >= 5 && referlength < 10 ? 10 : 5}{" "}
                    {t("thankstxt2")}{" "}
                    <span style={{ fontFamily: " 'Montserrat-SemiB'" }}>
                      {referlength >= 5 &&
                        referlength < 10 &&
                        convertGlobalPrice(
                          "papAwH0XoKC3AmT9YmR7",
                          constant.referralPrice[2],
                          !selectedcurrency
                            ? currencydefault
                            : selectedcurrency,
                          currencies
                        )}{" "}
                      {referlength > 0 &&
                        referlength < 5 &&
                        convertGlobalPrice(
                          "papAwH0XoKC3AmT9YmR7",
                          constant.referralPrice[1],
                          !selectedcurrency
                            ? currencydefault
                            : selectedcurrency,
                          currencies
                        )}{" "}
                      {!selectedcurrency
                        ? i18n.language == "en"
                          ? currencies.filter(
                              (currency) => currency.id === currencydefault
                            )[0].name
                          : currencies.filter(
                              (currency) => currency.id === currencydefault
                            )[0].nameAr
                        : i18n.language == "en"
                        ? currencies.filter(
                            (currency) => currency.id === selectedcurrency
                          )[0].name
                        : currencies.filter(
                            (currency) => currency.id === selectedcurrency
                          )[0].nameAr}
                    </span>{" "}
                    {t("thankstxt3")}
                    <div className="pt-3">
                      {t("thankstxt4")}{" "}
                      {referlength > 5 && referlength <= 10 && nbentre510}{" "}
                      {referlength > 0 && referlength < 5 && nbpluspetit5}{" "}
                      {t("thankstxt5")}
                    </div>
                  </>
                ) : (
                  <>
                    {t("thankstxt6")}
                    <div className="pt-2">
                      {t("thankstxt7")}{" "}
                      <span style={{ fontFamily: " 'Montserrat-SemiB'" }}>
                        {convertGlobalPrice(
                          "papAwH0XoKC3AmT9YmR7",
                          constant.referralPrice[2],
                          !selectedcurrency
                            ? currencydefault
                            : selectedcurrency,
                          currencies
                        )}{" "}
                        {!selectedcurrency
                          ? i18n.language == "en"
                            ? currencies.filter(
                                (currency) => currency.id === currencydefault
                              )[0].name
                            : currencies.filter(
                                (currency) => currency.id === currencydefault
                              )[0].nameAr
                          : i18n.language == "en"
                          ? currencies.filter(
                              (currency) => currency.id === selectedcurrency
                            )[0].name
                          : currencies.filter(
                              (currency) => currency.id === selectedcurrency
                            )[0].nameAr}
                      </span>{" "}
                      {t("thankstxt8")}
                    </div>
                  </>
                )}
              </div>
            </div>
            {referlength >= 10 ? null : (
              <div className="justify-content-center d-flex w-100 text-center pt-3 pb-2">
                <div
                  className="justify-content-center d-flex btn-refer"
                  onClick={() =>
                    navigate("/referral-program-Libas") & setShow(false)
                  }
                >
                  {t("REFER NOW")}
                </div>
              </div>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default ThankYouModal;
